module.exports = __webpack_public_path__ + "img/guigang.fd0b4c72.jpg";